<template>
  <b-modal
    v-model="_value"
    dialog-class="mandala-evaluation-modal"
    header-class="mandala-evaluation-modal__header"
    content-class="mandala-evaluation-modal__content"
    :body-class="['mandala-evaluation-modal__body', { 'is-locked': !canShowBody }]"
    size="xl"
    hide-footer>
    <template #modal-header>
      <IconButton
        class="mandala-evaluation-modal__header__close-button top"
        color="white"
        icon="close"
        @click="_value = false" />
      <IconButton
        v-if="canShowBody"
        class="mandala-evaluation-modal__header__close-button bottom"
        color="white"
        icon="close"
        @click="_value = false" />
    </template>
    <template
      #default>
      <div class="mandala-evaluation-modal__body-inner">
        <div class="d-none d-md-block mandala-evaluation-modal__user">
          <MandalaEvaluationPreviewItem
            :user="user"
            :mandala-evaluations="mandalaEvaluations"
            :mandala-goal-template="mandalaGoalTemplate"
            :year-months="yearMonths"
            :like-ids="likeIds"
            :chart-padding="{ top: 40 }"
            :chart-styles="{
              minHeight: '320px',
              maxWidth: '400px',
            }"
            :chart-message-offset-y="30"
            :display-legend="true"
            :is-col="false"
            back-to="recordMandalaList"
            @like="$emit('like', $event)" />
        </div>
        <div
          
          class="mandala-evaluation-modal__goal">
          <MandalaEvaluationModalBody
            v-if="hasMandalaEvaluations"
            :mandala-evaluations="mandalaEvaluations"
            :mandala-goal-template="mandalaGoalTemplate"
            :is-manager="isManager" />
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
            style="font-size: 16px;">
            自己評価がありません
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'
import MandalaEvaluationModalBody from '@/components/view/MandalaEvaluationModalBody.vue'
import MandalaEvaluationPreviewItem from '@/components/view/records/MandalaEvaluationPreviewItem.vue'
export default {
  components: {
    IconButton,
    MandalaEvaluationModalBody,
    MandalaEvaluationPreviewItem,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    },
    mandalaEvaluations: {
      type: Array,
      required: true
    },
    mandalaGoalTemplate: {
      type: Object,
      default: null
    },
    yearMonths: {
      type: Array,
      required: true
    },
    likeIds: {
      type: Array,
      default: () => []
    },
    isMine: {
      type: Boolean,
      default: false
    },
    isManager: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    hasMandalaEvaluations() {
      return this.mandalaEvaluations.length !== 0
    },
    canShowEntryName() {
      if (!this.mandalaGoalTemplate) return true
      return this.isMine || this.isManager || !this.mandalaGoalTemplate.isLockEntryNames
    },
    canShowActionGoalNames() {
      if (!this.mandalaGoalTemplate) return true
      return this.isMine || this.isManager || !this.mandalaGoalTemplate.isLockActionGoalNames
    },
    canShowBody() {
      return this.canShowEntryName || this.canShowActionGoalNames
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap';

.mandala-evaluation-modal {

  &__body-inner {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    background-color: $white;
    border-radius: 0.3em;
    padding: 16px;
  }

  &__user {
    width: 400%;
    min-width: 320px;
    max-width: 400px;
  }

  &__goal {
    // モバイルの場合はグラフを表示しないため、ダイアログ内部でスクロールさせない
    @include media-breakpoint-up(md) {
      max-width: 400px;
      max-height: 800px;
      overflow-y: scroll;
    }
  }
  
  &__content.modal-content{
    position: relative;
    background-color: transparent;
    border: none;
    margin-top: calc(env(safe-area-inset-top));
    margin-bottom: 60px;
  }
  
  &__header.modal-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background-color: transparent;
    margin-bottom: 12px;
    border: none;
    padding: 0;
  }
  &__body.modal-body {
    background-color: transparent;
    padding: 0;
    font-size: 12px;
    font-weight: bold;
    &.is-locked {
      background-color: transparent;
    }
  }

  .mandala-evaluation-modal__header__close-button {

    &.bottom {
      position: absolute;
      bottom: -40px;
      right: 0;
    }
  }
}
</style>